<template>
<body>
  <div>
    <div class="sample">
      <img :src="image_url ? image_url : default_url" atl>
      <p>签证样图</p>
    </div>
    <div class="sample_button">
      <a @click="close" href="javascript:void(0)">
        <input type="button" value="关闭">
      </a>
    </div>
  </div>
</body>
</template>
<script>
import loading from '@/assets/images/html/loading.gif'
export default {
  name: 'ViewSampleImg',
  componentName: 'ViewSampleImg',
  data () {
    return {
      url: 'attachment_info/info_and_cache/',
      attachment_info_id: 0,
      route_plan_id: 0,
      route_id: 0,
      source: '',
      attachment: {},
      image_url: '',
      default_url: loading,
    }
  },
  created () {
    this.route_id = this.$route.query.route_id
    this.attachment_info_id = this.$route.query.attachment_info_id
    this.route_plan_id = this.$route.query.route_plan_id
    this.source = this.$route.query.source
    this.$myGet(this.url + this.attachment_info_id)
      .then(res => {
        this.attachment = res.response.data.data
        this.image_url = res.response.data.url
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message, 'error')
      })
  },
  methods: {
    close () {
      window.close()
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/html/three.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/viewSampleImg.vue